module.exports = __webpack_public_path__ + "img/36.92c7aabd.jpg";